import jwt from 'jsonwebtoken';

import { ERROR_TAGS } from '@/modules/error/domain/error.constants';
import { getLoggerService } from '@/modules/logger/infrastructure/loggerService';
import { COOKIES } from '@/services/constants';
import { Helpers } from '@/services/helpers';

export default function ({ redirect, $cookies, store, query }) {
  const { token, redirect_url: redirectUrl, redirect_path: redirectPath } = query;

  try {
    const data = jwt.decode(token);
    const expiresAt = data.exp * 1000;

    // Token expired.
    if (expiresAt < Date.now()) {
      return redirect(Helpers.getLoginUrl(query));
    }

    store.dispatch('auth/setUuidLoginAction', data.uuid);
    store.dispatch('auth/setUserLoginEmailAction', data.email);
    store.dispatch('auth/setJwtData', data);

    $cookies.set(COOKIES.token, token, {
      expires: new Date(expiresAt),
      path: '/',
      secure: process.env.NODE_ENV !== 'development',
    });

    return redirect(redirectPath || redirectUrl || '/manage');
  } catch (e) {
    const { logger } = getLoggerService();
    logger.error('Error decoding JWT token in authenticateUser middleware', {
      tags: [ERROR_TAGS.UNAUTHORIZED],
      error: e.message,
      hasToken: !!token,
    });
    return redirect(Helpers.getLoginUrl(query));
  }
}
